import cloneDeep from "lodash/cloneDeep";
import { DefaultSettings, ISettingsProps } from "./Models.ts";
import { OperationOptions, Operations } from "./Constants.ts";

/**
 * Builds the initial generator settings for a single-operation route
 * (e.g. a multiplication landing page), starting from DefaultSettings and
 * pinning the operation. Shared by App.js routes and the Landing pages.
 */
export function worksheetgeneratorSettings(
    operation: Operations,
    createWordProblems: boolean = false
): ISettingsProps {
    const settings = cloneDeep(DefaultSettings);
    settings.AllOperations = false;
    settings.Page = operation;
    settings.Operators = [OperationOptions.filter((op) => op.value === operation)[0]];
    settings.WordProblems = createWordProblems;
    return settings;
}
